// extracted by mini-css-extract-plugin
export var copyableField = "_s5-4";
export var customerBadge = "_s5-0";
export var customerInfoTitle = "_s5-2";
export var details = "_s5-1";
export var dropdownContainer = "_s5-5";
export var dropdownImage = "_s5-6";
export var editAssigneeForm = "_s5-a";
export var editButton = "_s5-3";
export var email = "_s5-7";
export var hidden = "_s5-d";
export var input = "_s5-8";
export var saveButton = "_s5-b";
export var shopifyIcon = "_s5-c";
export var suggestionBadge = "_s5-e";
export var suggestionText = "_s5-f";
export var username = "_s5-9";